
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/legal/privacy-policy-for-california",
      function () {
        return require("private-next-pages/[lang]/legal/privacy-policy-for-california/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/legal/privacy-policy-for-california"])
      });
    }
  